export const CONSTANT_CUSTOMER_SUPPORT_INFO ={
    phone1: '+20 122 648 6855',
    phone: '+20 128 588 5966',
    workingHours: '10 AM - 9 PM'
}
